// extracted by mini-css-extract-plugin
export var imgsContainer = "Footer-module--imgsContainer--13mrC";
export var iconImg = "Footer-module--iconImg--2r3DS";